export * from './erinnerung-entfernt.interface';
